module.exports = __webpack_public_path__ + "img/P150T_weapon_70.62d7469e.png";